import React, {ChangeEvent, Component, ReactNode} from 'react'
import AssocManagementRepository from './AssocManagementRepository'
import {AssocDirectorListLocationState} from './AdminAssocDirectorListPage'
import EventEmitterExAdmin from '../shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../shared/hoc/createAdminPage'
import SortableTableHeader, {
    SortableTableHeaderCell,
} from '../../styledComponents/adminPage/SortablePaginationTableHeader'
import SortablePaginationTable from '../../styledComponents/adminPage/SortablePaginationTable'
import SortablePaginationTableBody from '../../styledComponents/adminPage/SortablePaginationTableBody'
import {
    AssocStatus,
    AssocStatusCondominiumInfo,
    AssocStatusSearchCondition,
    AssocTermStatus,
    isAssocStatusCondominiumInfoList,
} from './model/AssocStatus'
import {Nullable} from '../../app/TypeHelpers'
import {LeftColumnFlexContainer, LeftRowFlexContainer} from '../../styledComponents/FlexComponents'
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined'
import {EditLink} from '../../styledComponents/adminPage/Links'
import {NewEllipsisText, PreWrap} from './AssocDirectorCommon'
import styled from 'styled-components'
import {ASSOC_CHAIRMAN_REGISTRATION_STATUS, SELECT_CONDOMINIUM_TYPE} from '../../CodeMaster'
import {Colors, DisplaySizeValue, FontSizeInPixel, FontWeights} from '../../styledComponents/Constants'
import {COMMON_CONSTANTS} from '../../CommonConstants'
import {ContentsForPagination} from '../shared/ContentsForPagination'
import {Box, Link, Snackbar, SnackbarContent, SortDirection, TableCell, TableRow} from '@mui/material';
import NatCondominiumGroupRepo
    from '../../__NoAutomatedTests/components/condominiumGroup/repository/NatCondominiumGroupRepo'
import {
    CondominiumGroupData,
    NatGetCondominiumGroup,
} from '../../__NoAutomatedTests/components/condominiumGroup/repository/NatGetCondominiumGroup'
import NatCondominiumGroupSelectComponent
    from '../../__NoAutomatedTests/components/common/NatCondominiumGroupSelectComponent'
import {SessionStorageHelper} from '../../SessionStorageHelper'
import {FlexGridArea} from '../../styledComponents/GridComponents'
import {AdminDefaultButton} from '../../styledComponents/adminPage/Buttons'
import PPInput from '../shared/forms/PPInput'
import HintButton from '../shared/pageBaseComponents/HintButton'
import {Messages} from '../../Messages'
import PPCheckboxGroup from '../shared/forms/PPCheckboxGroup'
import ListSearchFormArea from '../../styledComponents/adminPage/ListSearchFormArea'
import {PageFotterAreaRight, PageMainArea} from '../shared/hoc/withAdminPageTemplate'
import {
    AdminLoginInfoSessionStorageKey,
    NatAdminLoginInfoSessionStorageHelper,
} from '../../__NoAutomatedTests/common/authentication/NatAdminLoginInfoSessionStorageHelper'
import NatCondominiumSelectionComponent
    from '../../__NoAutomatedTests/components/common/admin/NatCondominiumSelectionComponent'
import NatCondominiumRepo from '../../__NoAutomatedTests/components/condominium/repository/NatCondominiumRepo'
import {CondominiumInfo} from '../../__NoAutomatedTests/components/condominium/repository/NatGetCondominiumList'
import {CookieHelper} from '../../CookieHelper'
import HoverPopupArea from '../shared/HoverPopupArea'
import {DisplayItemDividerDialog} from '../reservations/components/CommonStyle'
import {formatDateLocalSlashSeparator, formatDateTimeLocalSlashSeparator} from '../../formatters/formatMoment'
import {Information} from '../../network/response/Information'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import AdminAssocStatusMemoEditDialog from './AdminAssocStatusMemoEditDialog'
import {AdminDialog} from '../shared/pageBaseComponents/AdminDialog'
import {AdminSessionUtil, KEY_ASSOC_STATUS_LIST_SEARCH_CONDITION} from '../../app/AdminSessionUtil'
import {Location} from 'react-router-dom'
import NatResidentUserRepo from '../../__NoAutomatedTests/components/residentUser/repository/NatResidentUserRepo';


const COOKIE_KEY_BASE_ASSOC_STATUS_CONDOMINIUM_INFO: string = 'adminAssocStatusListPage-SelectedCondominiumInfo'

interface Props {
    condominiumGroupRepo: NatCondominiumGroupRepo
    condominiumRepo: NatCondominiumRepo
    assocManagementRepo: AssocManagementRepository
    location: Location<AssocDirectorListLocationState>
    eventEmitter: EventEmitterExAdmin
    adminSessionUtil: AdminSessionUtil
    residentUserRepo: NatResidentUserRepo
}

interface State {
    condominiumGroupData: CondominiumGroupData
    searchCondition: AssocStatusSearchCondition
    isOpenSelectCondominiumDiaLog: boolean
    selectedCondominiumGroupId: number
    selectedCondominiumInfoList: AssocStatusCondominiumInfo[]
    keyword: Nullable<string>
    selectedAssocChairmanRegistrationStatusList: string[]
    assocStatusTotalCount: number
    assocStatusViewList: AssocStatus[]
    isLoadCompleted: boolean
    csvButtonDisable: boolean
    isMemoDialogOpen: boolean
    selectAssocStatusMemo: Nullable<AssocStatus>
    isMemoRegistrationCompleted: boolean
    memoRegistrationCompletedMessage: Nullable<string>
}

interface AssocChairmanInfo {
    room: string
    name: string
}

class AdminAssocStatusListPage extends Component<Props & AdminPagePropsSet, State> {
    cookieKey: string

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        const loginUserAdminId = NatAdminLoginInfoSessionStorageHelper
            .getStringItemOrNull(AdminLoginInfoSessionStorageKey.LOGIN_USER_ADMIN_ID)
        const loginUserCondominiumGroupId = NatAdminLoginInfoSessionStorageHelper
            .getNumberItemOrNull(AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_ID)
        if (loginUserAdminId === null || loginUserCondominiumGroupId === null) {
            throw Error('ログインユーザの管理者ID、所属物件グループが取得できなかった。')
        }
        this.cookieKey = `${COOKIE_KEY_BASE_ASSOC_STATUS_CONDOMINIUM_INFO}-${loginUserAdminId}-${loginUserCondominiumGroupId}`

        const sessionSearchCondition =
            SessionStorageHelper.getObject<AssocStatusSearchCondition>(KEY_ASSOC_STATUS_LIST_SEARCH_CONDITION)

        const condominiumGroupId = sessionSearchCondition?.condominiumGroupId ?? loginUserCondominiumGroupId
        const condominiumInfoList = this.loadCondominiumInfoListFromCookie()
        const keyword = sessionSearchCondition?.keyword ?? null
        const assocChairmanRegistrationStatusList = sessionSearchCondition?.assocChairmanRegistrationStatusList ?? [
            ASSOC_CHAIRMAN_REGISTRATION_STATUS.ACTION_REQUIRED.value,
            ASSOC_CHAIRMAN_REGISTRATION_STATUS.NOTICE.value,
            ASSOC_CHAIRMAN_REGISTRATION_STATUS.DONE.value,
        ]
        this.state = {
            condominiumGroupData: {
                level1CondominiumGroupId: '',
                level1CondominiumGroupName: '',
                level1CondominiumGroupVersion: 0,
                level2CondominiumGroupInfo: [],
            },
            searchCondition: {
                condominiumGroupId: condominiumGroupId,
                condominiumCdList: condominiumInfoList.map(condominiumInfo => condominiumInfo.condominiumCd),
                keyword: keyword,
                assocChairmanRegistrationStatusList: assocChairmanRegistrationStatusList,
                sortKey: 'assocChairmanRegistrationStatus',
                sortDirection: 'asc',
                rowsPerPage: sessionSearchCondition?.rowsPerPage ?? 20,
                page: COMMON_CONSTANTS.FIRST_PAGE,
            },
            isOpenSelectCondominiumDiaLog: false,
            selectedCondominiumGroupId: condominiumGroupId,
            selectedCondominiumInfoList: condominiumInfoList,
            keyword: keyword,
            selectedAssocChairmanRegistrationStatusList: assocChairmanRegistrationStatusList,
            assocStatusTotalCount: 0,
            assocStatusViewList: [],
            isLoadCompleted: false,
            csvButtonDisable: false,
            isMemoDialogOpen: false,
            selectAssocStatusMemo: null,
            isMemoRegistrationCompleted: false,
            memoRegistrationCompletedMessage: null,
        }

        this.handleSelectedCondominiumGroupIdChange = this.handleSelectedCondominiumGroupIdChange.bind(this)
        this.handleKeywordChange = this.handleKeywordChange.bind(this)
        this.handleSelectedAssocChairmanRegistrationStatusChecked =
            this.handleSelectedAssocChairmanRegistrationStatusChecked.bind(this)
        this.handleSearchAssocStatusButtonClick = this.handleSearchAssocStatusButtonClick.bind(this)
        this.handleSelectCondominiumButtonClick = this.handleSelectCondominiumButtonClick.bind(this)
        this.closeSelectCondominiumDiaLog = this.closeSelectCondominiumDiaLog.bind(this)
        this.setSelectedCondominiumInfoList = this.setSelectedCondominiumInfoList.bind(this)
        this.handleRowsPerPageChange = this.handleRowsPerPageChange.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.handleSortOrderChange = this.handleSortOrderChange.bind(this)
        this.handleAssocStatusExtract = this.handleAssocStatusExtract.bind(this)
        this.handleClickMemoEditDialog = this.handleClickMemoEditDialog.bind(this)
        this.handleCloseMemoEditDialog = this.handleCloseMemoEditDialog.bind(this)
        this.handleMemoResisterCompleted = this.handleMemoResisterCompleted.bind(this)
        this.handleCloseMemoResisterCompletedSnackBar = this.handleCloseMemoResisterCompletedSnackBar.bind(this)
        this.renderMemoRegistrationCompletedSnackBar = this.renderMemoRegistrationCompletedSnackBar.bind(this)
        this.renderMemoEditDialog = this.renderMemoEditDialog.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const {
            asyncCallFunction,
            eventEmitter,
            condominiumGroupRepo,
        } = this.props

        const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await asyncCallFunction(
            condominiumGroupRepo.getCondominiumGroup.bind(condominiumGroupRepo),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        if (!condominiumGroupResponse || condominiumGroupResponse.details === null) {
            return
        }

        await this.updateAssocStatusList()

        this.setState({
            condominiumGroupData: condominiumGroupResponse.details,
            isLoadCompleted: true,
        })
    }

    loadCondominiumInfoListFromCookie(): AssocStatusCondominiumInfo[] {
        const cookieCondominiumInfoListJson = CookieHelper.getStringValue(this.cookieKey)
        let condominiumInfoList: AssocStatusCondominiumInfo[] = []

        if (cookieCondominiumInfoListJson) {
            try {
                const cookieCondominiumInfoList = JSON.parse(cookieCondominiumInfoListJson) as unknown
                if (isAssocStatusCondominiumInfoList(cookieCondominiumInfoList)) {
                    condominiumInfoList = cookieCondominiumInfoList
                        .map(condominiumInfo => ({
                            condominiumCd: condominiumInfo.condominiumCd
                        }))
                }
            } catch (e) {
                // オブジェクト変換時のエラーは無視する
            }
        }

        return condominiumInfoList
    }

    async updateAssocStatusList(): Promise<void> {
        const {
            asyncCallFunction,
            eventEmitter,
            assocManagementRepo,
        } = this.props

        const {
            searchCondition,
            selectedCondominiumInfoList,
        } = this.state

        SessionStorageHelper.setObject(KEY_ASSOC_STATUS_LIST_SEARCH_CONDITION, searchCondition)
        CookieHelper.setStringValue(
            this.cookieKey,
            JSON.stringify(selectedCondominiumInfoList),
        )

        await eventEmitter.showLoading()
        try {
            const result: Nullable<ContentsForPagination<AssocStatus>> = await asyncCallFunction(
                assocManagementRepo.getAssocStatusList.bind(
                    assocManagementRepo,
                    searchCondition,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(eventEmitter)
                },
            )

            if (result === null) {
                return
            }

            this.setState({
                assocStatusTotalCount: result.totalContentsCount,
                assocStatusViewList: result.contents,
            })
        } finally {
            eventEmitter.closeLoading()
        }
    }

    handleSelectedCondominiumGroupIdChange(condominiumGroupId: number): void {
        if (condominiumGroupId === this.state.selectedCondominiumGroupId) {
            return;
        }
        this.setState({
            selectedCondominiumGroupId: condominiumGroupId,
            selectedCondominiumInfoList: [],
        })
    }

    handleKeywordChange(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            keyword: event.target.value || null, // 空文字はnullとする
        })
    }

    handleSelectedAssocChairmanRegistrationStatusChecked(label: string, checked: boolean): void {
        const {selectedAssocChairmanRegistrationStatusList} = this.state
        const checkedStatus = ASSOC_CHAIRMAN_REGISTRATION_STATUS.values()
            .find(assocChairmanRegistrationStatus => assocChairmanRegistrationStatus.label === label)
        if (!checkedStatus) {
            return
        }

        const assocChairmanRegistrationStatusSet = new Set(selectedAssocChairmanRegistrationStatusList)
        if (checked) {
            assocChairmanRegistrationStatusSet.add(checkedStatus.value)
        } else {
            assocChairmanRegistrationStatusSet.delete(checkedStatus.value)
        }

        this.setState({
            selectedAssocChairmanRegistrationStatusList: [...assocChairmanRegistrationStatusSet],
        })
    }

    handleSearchAssocStatusButtonClick(): void {
        const {
            searchCondition,
            selectedCondominiumGroupId,
            selectedCondominiumInfoList,
            keyword,
            selectedAssocChairmanRegistrationStatusList,
        } = this.state


        this.setState({
            searchCondition: {
                ...searchCondition,
                condominiumGroupId: selectedCondominiumGroupId,
                condominiumCdList: selectedCondominiumInfoList
                    .map(selectedCondominiumInfo => selectedCondominiumInfo.condominiumCd),
                keyword: keyword,
                assocChairmanRegistrationStatusList: selectedAssocChairmanRegistrationStatusList,
                page: COMMON_CONSTANTS.FIRST_PAGE,
            },
        }, this.updateAssocStatusList)
    }

    handleSelectCondominiumButtonClick(): void {
        this.setState({
            isOpenSelectCondominiumDiaLog: true,
        })
    }

    closeSelectCondominiumDiaLog(): void {
        this.setState({
            isOpenSelectCondominiumDiaLog: false,
        })
    }

    setSelectedCondominiumInfoList(selectedCondominiumInfoList: CondominiumInfo[]): void {
        this.setState({
            isOpenSelectCondominiumDiaLog: false,
            selectedCondominiumInfoList: selectedCondominiumInfoList.map(selectedCondominiumInfo => ({
                condominiumCd: selectedCondominiumInfo.condominiumCd
            })),
        })
    }

    handlePageChange(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): void {
        this.setState({
            searchCondition: {
                ...this.state.searchCondition,
                page: newPage,
            },
        }, this.updateAssocStatusList)
    }

    handleRowsPerPageChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            searchCondition: {
                ...this.state.searchCondition,
                rowsPerPage: Number(event.target.value),
                page: COMMON_CONSTANTS.FIRST_PAGE,
            },
        }, this.updateAssocStatusList)
    }

    getSortDirection(sortKey: string): SortDirection {
        return this.state.searchCondition.sortKey === sortKey
            ? this.state.searchCondition.sortDirection : false
    }

    handleSortOrderChange(sortKey: string): void {
        let sortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        this.setState({
            searchCondition: {
                ...this.state.searchCondition,
                sortKey: sortKey,
                sortDirection: sortDirection,
            },
        }, this.updateAssocStatusList)
    }

    async handleAssocStatusExtract(): Promise<void> {
        this.setState({csvButtonDisable: true}, async () => {
            await this.props.eventEmitter.showLoading()
            try {
                const tempLink: HTMLAnchorElement = document.createElement('a')
                tempLink.href = this.props.assocManagementRepo.getAssocStatusListCsv()
                document.body.appendChild(tempLink)
                tempLink.click()
            } finally {
                this.props.eventEmitter.closeLoading()
            }
            this.setState({csvButtonDisable: false})
        })
    }

    async handleCondominiumNameClick(assocStatus: AssocStatus): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.WOPCA0001.errorLevel,
                message: Messages.WOPCA0001.toString('全体モード', '物件モード'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: () => this.props.eventEmitter.closeDialog(),
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: () => {
                            this.props.adminSessionUtil.setCondominiumMode(
                                this.props,
                                assocStatus,
                            )
                        },
                    },
                ],
            },
        )
    }

    render(): ReactNode {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return <>
            {this.renderSearchCondition()}
            {this.renderAssocStatusTable()}
        </>
    }

    renderSearchCondition(): ReactNode {
        const {
            condominiumGroupData,
            isOpenSelectCondominiumDiaLog,
            selectedCondominiumGroupId,
            selectedCondominiumInfoList,
            keyword,
            selectedAssocChairmanRegistrationStatusList,
            assocStatusTotalCount,
        } = this.state

        const assocChairmanRegistrationStatusCheckBoxData = ASSOC_CHAIRMAN_REGISTRATION_STATUS.values().map(
            assocChairmanRegistrationStatus => ({
                label: assocChairmanRegistrationStatus.label,
                checked: selectedAssocChairmanRegistrationStatusList.includes(assocChairmanRegistrationStatus.value),
            }))

        const selectedCondominiumCdList: CondominiumInfo[] = selectedCondominiumInfoList.map(selectedCondominium => {
            return {
                condominiumCd: selectedCondominium.condominiumCd,
                condominiumName: '',
                condominiumGroupName: '',
                prefectureCd: '',
                address2: '',
                updateDatetime: '',
                releaseFlg: ''
            }
        })
        return <>
            <ListSearchFormArea
                onEnterKey={this.handleSearchAssocStatusButtonClick}
                searchResult={assocStatusTotalCount === 0 ?
                    {noResultMessage: Messages.IOPCC0014.toString()} : undefined}
            >
                <Box height={'8px'}/>
                <SearchForm>
                    <NonGridDiv className={'assocStatusRow'}>
                        <FlexGridArea area={'condominiumGroupSelectLabel'}>
                            <SearchFormText>
                                物件グループを選択
                            </SearchFormText>
                        </FlexGridArea>
                        <FlexGridArea area={'condominiumGroupSelect'}>
                            <SearchFormInputContainer>
                                <NatCondominiumGroupSelectComponent
                                    condominiumGroup={condominiumGroupData}
                                    defaultValue={selectedCondominiumGroupId}
                                    onChangeSelectedCondominiumGroupId={this.handleSelectedCondominiumGroupIdChange}
                                    requiredFlag={true}
                                />
                            </SearchFormInputContainer>
                        </FlexGridArea>
                    </NonGridDiv>
                    <NonGridDiv className={'assocStatusRow'}>
                        <FlexGridArea area={'condominiumSelectLabel'}>
                            <SearchFormText>
                                物件リストから選択
                            </SearchFormText>
                        </FlexGridArea>
                        <FlexGridArea area={'condominiumSelectHint'}>
                            <HintButton message={Messages.HASOA0002.message}/>
                        </FlexGridArea>
                        <FlexGridArea area={'condominiumSelectButton'}>
                            <AdminDefaultButton onClick={this.handleSelectCondominiumButtonClick}>
                                物件を選択する
                            </AdminDefaultButton>
                        </FlexGridArea>
                        <FlexGridArea area={'selectedCondominiums'}>
                            <NewEllipsisText lineHeightInPixel={21} numOfLines={2}>
                                {selectedCondominiumInfoList
                                    .map(selectedCondominiumInfo => selectedCondominiumInfo.condominiumCd)
                                    .join('，')}
                            </NewEllipsisText>
                        </FlexGridArea>
                    </NonGridDiv>
                    <NonGridDiv className={'assocStatusRow'}>
                        <FlexGridArea area={'keywordLabel'}>
                            <SearchFormText>
                                キーワード検索
                            </SearchFormText>
                        </FlexGridArea>
                        <FlexGridArea area={'keywordHint'}>
                            <HintButton message={Messages.HASOA0001.message}/>
                        </FlexGridArea>
                        <FlexGridArea area={'keyword'}>
                            <SearchFormInputContainer>
                                <PPInput
                                    value={keyword ?? ''}
                                    onChange={this.handleKeywordChange}
                                    inputProps={{
                                        minLength: 0,
                                        maxLength: 50,
                                    }}
                                    placeholder={'物件コード、物件名、管理組合名、メモの内容で検索できます'}
                                    fullWidth
                                />
                            </SearchFormInputContainer>
                        </FlexGridArea>
                    </NonGridDiv>
                    <NonGridDiv className={'assocStatusRow'}>
                        <FlexGridArea area={'assocChairmanRegistrationStatusCheckLabel'}>
                            <SearchFormText>
                                理事長管理状況
                            </SearchFormText>
                        </FlexGridArea>
                        <FlexGridArea area={'assocChairmanRegistrationStatusCheck'}>
                            <PPCheckboxGroup
                                row
                                data={assocChairmanRegistrationStatusCheckBoxData}
                                onChangeChecked={this.handleSelectedAssocChairmanRegistrationStatusChecked}
                            />
                        </FlexGridArea>
                    </NonGridDiv>
                    <FlexGridArea area={'searchButton'}>
                        <AdminDefaultButton onClick={this.handleSearchAssocStatusButtonClick}>
                            管理組合を検索する
                        </AdminDefaultButton>
                    </FlexGridArea>
                </SearchForm>
            </ListSearchFormArea>
            <Box height={'10px'}/>
            <PageFotterAreaRight>
                <AdminDefaultButton
                    onClick={this.handleAssocStatusExtract}
                    disabled={this.state.csvButtonDisable}
                >
                    所属物件グループの登録状況抽出
                </AdminDefaultButton>
            </PageFotterAreaRight>
            {isOpenSelectCondominiumDiaLog &&
                <NatCondominiumSelectionComponent
                    selectCondominiumType={SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value}
                    condominiumRepo={this.props.condominiumRepo}
                    condominiumGroupRepo={this.props.condominiumGroupRepo}
                    closeSelectCondominiumDiaLog={this.closeSelectCondominiumDiaLog}
                    setSelectedExclusionCondominiumInfo={this.setSelectedCondominiumInfoList}
                    eventEmitter={this.props.eventEmitter}
                    selectedCondominiumGroupId={selectedCondominiumGroupId}
                    navigate={this.props.navigate}
                    location={this.props.location}
                    asyncCallFunction={this.props.asyncCallFunction}
                    excludeCondominium={selectedCondominiumCdList}
                />}
        </>
    }

    renderStatusItem = (title: string, hint: string, content: string) => {
        return <>
            <StatusItem>
                <StatusItemTitle>{title}</StatusItemTitle>
                <StatusItemHint><HintButton message={hint}/></StatusItemHint>
                <StatusItemContent>{content}</StatusItemContent>
            </StatusItem>
        </>
    }

    renderStatus = (assocTermStatus: Nullable<AssocTermStatus>) => {
        let termText

        if (assocTermStatus) {
            termText = `${assocTermStatus.termName}\n${formatDateLocalSlashSeparator(assocTermStatus.termStartDate)} ～ ${formatDateLocalSlashSeparator(assocTermStatus.termEndDate)}`
        } else {
            termText = '登録されていません'
        }

        const assocChairmanInfoList: AssocChairmanInfo[] = []

        if (assocTermStatus && assocTermStatus.assocChairmanList.length > 0) {
            assocTermStatus.assocChairmanList.map(assocChairman => {
                assocChairmanInfoList.push({
                    room: assocChairman.assocChairmanRoomInfoList.map(roomInfo => `${roomInfo.ridgeName} ${roomInfo.roomNumber}`).join('，'),
                    name: assocChairman.assocChairmanName,
                })
            })
        } else {
            assocChairmanInfoList.push({
                room: '登録されていません',
                name: '（未登録）',
            })
        }

        return <AssocTermInfoArea>
            <AssocTermArea>
                {this.renderStatusItem('任期', '物件モードの理事会任期一覧\nから設定できます', termText)}
            </AssocTermArea>
            <DisplayItemDividerDialog/>
            <AssocChairmanListArea>
                {assocChairmanInfoList.map((assocChairmanInfo, index) =>
                    <AssocChairmanArea key={index}>
                        {this.renderStatusItem(
                            '理事長', '物件モードの役員一覧\nから設定できます', assocChairmanInfo.room,
                        )}
                        {this.renderStatusItem(
                            '利用登録',
                            '認証キーをお持ちでない場合には、\n居住者ユーザ申請から\n通知状発行（再発行）申請ができます',
                            assocChairmanInfo.name,
                        )}
                    </AssocChairmanArea>
                )}
            </AssocChairmanListArea>
            {assocTermStatus?.hasChairmanAbsentTerm &&
                <HasChairmanAbsentTermText>
                    理事長の不在期間があります。
                </HasChairmanAbsentTermText>
            }
        </AssocTermInfoArea>
    }

    renderStatusDialog = (status: AssocStatus) => {
        return <>
            <StatusDialog>
                <StatusHeaderArea>
                    {status.assocName}
                </StatusHeaderArea>
                <div>
                    <StatusTitle>現任期</StatusTitle>
                    {this.renderStatus(status.assocChairmanStatus.currentTermStatus)}
                </div>
                <div>
                    <StatusTitle>次期任期</StatusTitle>
                    {this.renderStatus(status.assocChairmanStatus.nextTermStatus)}
                </div>
            </StatusDialog>
        </>
    }

    handleClickMemoEditDialog(index: number): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
        this.setState({
            selectAssocStatusMemo: this.state.assocStatusViewList[index],
            isMemoDialogOpen: true,
        })
    }

    handleCloseMemoEditDialog(): void {
        this.setState({
            isMemoDialogOpen: false,
        })
    }

    handleMemoResisterCompleted(information: Information): void {
        this.updateAssocStatusList()
        this.setState({
            memoRegistrationCompletedMessage: information.message,
            isMemoDialogOpen: false,
            isMemoRegistrationCompleted: true,
        })
    }

    handleCloseMemoResisterCompletedSnackBar(): void {
        this.setState({
            isMemoRegistrationCompleted: false,
        })
    }

    renderMemoRegistrationCompletedSnackBar(): ReactNode {
        return <>
            <Snackbar open={this.state.isMemoRegistrationCompleted}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                      autoHideDuration={4000}
                      onClose={this.handleCloseMemoResisterCompletedSnackBar}>
                <SnackbarContent
                    style={{backgroundColor: '#00838a', color: 'white', fontWeight: FontWeights.Bold}}
                    message={
                        <>
                            <LeftRowFlexContainer>
                                <CheckCircleOutlineIcon titleAccess={'information'}/>
                                <SnackBarBox ml={'5px'}>{this.state.memoRegistrationCompletedMessage}</SnackBarBox>
                            </LeftRowFlexContainer>
                        </>
                    }
                ></SnackbarContent>
            </Snackbar>
        </>
    }

    renderMemoEditDialog(): ReactNode {
        return <>
            <AdminDialog
                open={this.state.isMemoDialogOpen}
                maxWidth={'lg'}
            >
                <AdminAssocStatusMemoEditDialog
                    onSubmit={this.handleMemoResisterCompleted}
                    onCancel={this.handleCloseMemoEditDialog}
                    assocManagementRepo={this.props.assocManagementRepo}
                    assocStatus={this.state.selectAssocStatusMemo}
                    eventEmitter={this.props.eventEmitter}
                />
            </AdminDialog>
        </>
    }

    renderAssocStatusLabel(assocStatus: AssocStatus): ReactNode {
        const notSubject = assocStatus.assocChairmanStatus.assocStatus ===
            ASSOC_CHAIRMAN_REGISTRATION_STATUS.NOT_SUBJECT

        const assocStatusLabel = <AssocStatusLabel status={assocStatus.assocChairmanStatus.assocStatus}>
            <AssocStatusLabelText>
                {assocStatus.assocChairmanStatus.assocStatus.label}
            </AssocStatusLabelText>
            <AssocStatusIcon disabled={notSubject}/>
        </AssocStatusLabel>

        return notSubject
            ? assocStatusLabel
            : <>
                <HoverPopupArea
                    anchor={'top-center'}
                    content={this.renderStatusDialog(assocStatus)}
                >
                    {assocStatusLabel}
                </HoverPopupArea>
            </>
    }

    renderAssocStatusTable(): ReactNode {
        if (this.state.assocStatusTotalCount === 0) {
            return
        }

        const headers: SortableTableHeaderCell[] = [
            {
                id: 'condominiumCd',
                label: '物件コード',
                align: 'left',
                sortable: true,
                direction: this.getSortDirection('condominiumCd'),
                width: '120px',
            },
            {
                id: 'condominiumName',
                label: '物件グループ / 物件名',
                align: 'left',
            },
            {
                id: 'assocName',
                label: '管理組合名',
                align: 'left',
            },
            {
                id: 'assocChairmanRegistrationStatus',
                label: '理事長管理状況',
                align: 'center',
                sortable: true,
                direction: this.getSortDirection('assocChairmanRegistrationStatus'),
                width: '156px',
            },
            {
                id: 'assocStatusMemo',
                label: 'メモ',
                align: 'left',
                width: '300px',
            },
            {
                id: 'assocStatusMemoEdit',
                label: '',
                align: 'left',
                width: '104px',
            },
        ]

        return (
            <PageMainArea>
                <SortablePaginationTable
                    paginationProps={{
                        count: this.state.assocStatusTotalCount,
                        rowsPerPage: this.state.searchCondition.rowsPerPage,
                        page: this.state.searchCondition.page,
                        onPageChange: this.handlePageChange,
                        onRowsPerPageChange: this.handleRowsPerPageChange,
                    }}
                >
                    <SortableTableHeader
                        noWrap
                        headers={headers}
                        onSortOrderChange={this.handleSortOrderChange}
                    />
                    <SortablePaginationTableBody>
                        {this.state.assocStatusViewList.map((item, index) =>
                            <TableRow key={index} >
                                <OverflowWrapTableCell>
                                    <Link
                                        component={'button'}
                                        onClick={() => this.handleCondominiumNameClick(item)}
                                        underline="hover">
                                        {item.condominiumCd}
                                    </Link>
                                </OverflowWrapTableCell>
                                <OverflowWrapTableCell>
                                    <LeftColumnFlexContainer>
                                        <div>
                                            {item.condominiumGroupName}
                                        </div>
                                        <div>
                                            {item.condominiumName}
                                        </div>
                                    </LeftColumnFlexContainer>
                                </OverflowWrapTableCell>
                                <OverflowWrapTableCell>{item.assocName}</OverflowWrapTableCell>
                                <OverflowWrapTableCell align={'center'}>
                                    {this.renderAssocStatusLabel(item)}
                                </OverflowWrapTableCell>
                                <OverflowWrapTableCell>
                                    {item.assocStatusMemo &&
                                        <HoverPopupArea
                                            anchor={'top-end'}
                                            content={
                                                <MemoDialog>
                                                    <MemoHeaderArea>
                                                        {item.assocName}
                                                    </MemoHeaderArea>
                                                    <MemoContentArea>
                                                        <PreWrap>
                                                            {item.assocStatusMemo.content}
                                                        </PreWrap>
                                                    </MemoContentArea>
                                                    <MemoFooterArea>
                                                        {`${item.assocStatusMemo.updateUserFamilyName} ${item.assocStatusMemo.updateUserFirstName}（${item.assocStatusMemo.updateUserRole.label}）`}&emsp;{`${formatDateTimeLocalSlashSeparator(item.assocStatusMemo.updateDateTime)}`}
                                                    </MemoFooterArea>
                                                </MemoDialog>
                                            }
                                        >
                                            <NewEllipsisText
                                                lineHeightInPixel={21}
                                                numOfLines={2}
                                            >
                                                <PreWrap>
                                                    {item.assocStatusMemo.content}
                                                </PreWrap>
                                            </NewEllipsisText>
                                        </HoverPopupArea>
                                    }
                                </OverflowWrapTableCell>
                                <OverflowWrapTableCell>
                                    <EditLink noWrap onClick={() => this.handleClickMemoEditDialog(index)}>
                                        メモ編集
                                    </EditLink>

                                </OverflowWrapTableCell>
                            </TableRow>)
                        }
                    </SortablePaginationTableBody>
                </SortablePaginationTable>
                {this.renderMemoEditDialog()}
                {this.renderMemoRegistrationCompletedSnackBar()}
            </PageMainArea>
        );
    }
}

export default createAdminPage(AdminAssocStatusListPage)

const SearchForm = styled.div`
    display: grid;
    grid-template:
            "condominiumGroupSelectLabel . condominiumGroupSelect condominiumGroupSelect condominiumGroupSelect"
            "condominiumSelectLabel condominiumSelectHint condominiumSelectButton selectedCondominiums selectedCondominiums "
            "keywordLabel keywordHint keyword keyword keyword "
              "assocChairmanRegistrationStatusCheckLabel . assocChairmanRegistrationStatusCheck assocChairmanRegistrationStatusCheck searchButton "
              / max-content max-content max-content 1fr max-content;
    row-gap: 16px;
    column-gap: 16px;
`

const NonGridDiv = styled.div`
    display: contents;
`

const SearchFormText = styled.div`
    padding: 0 12px;
`

const SearchFormInputContainer = styled.div`
    width: 600px;
`

const AssocStatusLabel = styled.div<{ status: ASSOC_CHAIRMAN_REGISTRATION_STATUS }>`
    display: flex;
    align-items: center;
    width: 120px;
    height: 42px;
    border-radius: 50px;
    background-color: ${props =>
            props.status === ASSOC_CHAIRMAN_REGISTRATION_STATUS.ACTION_REQUIRED ? '#F9BEC8'
                    : props.status === ASSOC_CHAIRMAN_REGISTRATION_STATUS.NOTICE ? '#F8E8CC'
                            : props.status === ASSOC_CHAIRMAN_REGISTRATION_STATUS.DONE ? '#ACE3E9'
                                    : '#EDEDED'};
    padding: 9px 22.5px;
    gap: 8px;
    user-select: none;
`

const AssocStatusLabelText = styled.div`
    flex-grow: 1;
`

const AssocStatusIcon = styled(LibraryBooksOutlinedIcon)<{ disabled: boolean }>`
    color: ${props => props.disabled ? Colors.AccentLight : 'inherit'};
`

const OverflowWrapTableCell = styled(TableCell)`
    overflow-wrap: anywhere;
`

const StatusDialog = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 24px;
    width: 394px;
    gap: 16px;
    text-align: left;
`

const StatusHeaderArea = styled.div`
    font-size: ${FontSizeInPixel.Body}px;
    background-color: #F1F1F1;
    font-weight: ${FontWeights.Bold};
    padding: 8px 11px;
`

const StatusTitle = styled.div`
    font-size: ${FontSizeInPixel.Body}px;
    font-weight: ${FontWeights.Bold};
    padding-left: 10px;
    border-left: 5px solid ${Colors.AccentLight};
`

const StatusItem = styled.div`
    display: flex;
    align-items: flex-start;
`

const StatusItemTitle = styled.div`
    display: inline-block;
    min-width: 90px;
`

const StatusItemHint = styled.div`
    display: flex;
    align-items: center;
    height: 21px;
    overflow: visible;
`

const StatusItemContent = styled.div`
    display: inline-block;
    white-space: pre-wrap;
    margin-left: 12px;
`

const AssocTermInfoArea = styled.div`
    margin-left: 16px;
`

const AssocTermArea = styled.div`
    margin-top: 8px;
    margin-bottom: 8px;
`

const AssocChairmanListArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    gap: 12px;
`

const AssocChairmanArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const HasChairmanAbsentTermText = styled.div`
    margin-top: 2px;
    color: ${Colors.Alert};
    font-size: ${FontSizeInPixel.Small}px;
`

const MemoDialog = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 24px;
    width: 558px;
    gap: 16px;
`

const MemoHeaderArea = styled.div`
    font-size: ${FontSizeInPixel.Body}px;
    background-color: #F1F1F1;
    font-weight: ${FontWeights.Bold};
    padding: 8px 11px;
`

const MemoContentArea = styled.div`
`

const MemoFooterArea = styled.div`
    font-size: ${FontSizeInPixel.Small}px;
    display: flex;
    justify-content: flex-end;
    color: ${Colors.AccentDark};
`

const SnackBarBox = styled(Box)`
    width: ${DisplaySizeValue.AdminWidthMin}px;
    max-width: ${DisplaySizeValue.AdminWidthMin}px;
    white-space: pre-wrap;
`
